import { useRef } from 'react';

export const useToggleExpand = () => {
    const refs = useRef<{ onToggleExpand: (e: boolean) => void }[]>([]);

    const onToggleExpand = (expand: boolean) => {
        refs.current.forEach((ref) => ref?.onToggleExpand(expand));
    };

    return {
        ref: (index: number) => (el: { onToggleExpand: (e: boolean) => void }) => (refs.current[index] = el),
        onToggleExpand,
    };
};
